import Container from "react-bootstrap/Container";
import { motion } from "framer-motion";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Button, Card, Col, Image, Row } from "react-bootstrap";
import { FeaturesRow } from "../../components/FeaturesRow";
import { useEffect } from "react";
import teamData from "./team.json"

interface OtherPage {
  buttonText: string;
  imageSrc: string;
  href: string;
}

interface TeamMember {
  name: string;
  position: string;
  role: string;
  description: string;
  website: string;
  image: string;
  email: string;
  linkedin: string;
  scholar: string;
  researchgate: string;
}

export const Home = () => {
  useEffect(() => {
    document.title = "PARSO - Home";
  }, []);

  const isMobile = window.innerWidth < 768;

  // Make a list of other pages
  const otherPages: OtherPage[] = [
    {
      buttonText: "View downloads",
      imageSrc: "images/Icons/Download.png",
      href: "download",
    },
    {
      buttonText: "View documentation",
      imageSrc: "images/Icons/Documentation.png",
      href: "documentation",
    },
    {
      buttonText: "View publications",
      imageSrc: "images/Icons/Publication.png",
      href: "publications",
    },
  ]

  const teamMembers: TeamMember[] = teamData.members;

  return (
    <>

      <Container
        fluid
        style={{
          marginTop: "20px",
          marginBottom: "100px",
        }}
      >




      {/* Hero Section (Top banner) */}
      {/* Hero Section (Top banner) */}
      {/* Hero Section (Top banner) */}
      {/* Hero Section (Top banner) */}
<Row
  className="position-relative text-center text-white"
  style={{
    marginBottom: 50,
    height: "100vh", // Make it cover the entire screen height
    overflow: "hidden",
  }}
>
  {/* Background image */}
  <Image
    src="/images/Home/Reactor3.jpg"
    fluid
    className="position-absolute w-100 h-100"
    style={{
      objectFit: "cover",
      filter: "grayscale(50%) brightness(60%)", // Slight grayscale with dimming for contrast
      zIndex: 1,
    }}
  />

  {/* Gradient Overlay */}
  <div
    className="position-absolute w-100 h-100"
    style={{
      background: "linear-gradient(180deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.7))", // Soft gradient overlay
      zIndex: 2,
    }}
  />

  {/* Foreground Text */}
  <div
    className="position-relative mx-auto my-auto"
    style={{ zIndex: 3, padding: "0 15px" }}
  >
    <h1 className="display-4 fw-bold" style={{ fontSize: "3rem" }}>
      PARSO
    </h1>
    <h2 className="mb-4" style={{ fontSize: "1.5rem", maxWidth: "80%", margin: "0 auto" }}>
      <strong>P</strong>article-packing <strong>a</strong>nd <strong>R</strong>adiation <strong>S</strong>hielding <strong>O</strong>ptimizer
      </h2>
    <h3 style={{ fontSize: "1.25rem", maxWidth: "80%", margin: "0 auto"}}>
      Optimize material mixtures for enhanced particle packing and radiation shielding properties
    </h3>

    <div className="d-flex justify-content-center mt-4">
      <Button
        className="mx-3 mt-4 px-4 py-2"
        variant="secondary"
        style={{
          fontSize: "1.1rem",
          borderRadius: "25px",
          transition: "all 0.3s ease-in-out",
        }}
        onClick={() => {
          const section = document.getElementById("learn-more-section");
          if (section) {
            section.scrollIntoView({ behavior: "smooth" });
          }
        }}
      >
        Learn More
      </Button>

      <Button
        className="mx-3 mt-4 px-4 py-2"
        variant="primary"
        style={{
          fontSize: "1.1rem",
          borderRadius: "25px",
          transition: "all 0.3s ease-in-out",
        }}
        href="download"
      >
        Download
      </Button>
    </div>
  </div>
</Row>





      {/* About Section */}
      {/* About Section */}
      {/* About Section */}
      {/* About Section */}
      <div id="learn-more-section">
      {getSectionHeading("About")}
      </div>
      <Container fluid>


        <Row style={{marginBottom: "50px"}} className="align-items-center">
        {/* Left Column (Text Content) */}
        <Col xs={12} md={{span: 4, offset: 1}}>
          <Card className="shadow-sm mb-4">
            <Card.Body>
              <Card.Text style={{ textAlign: "justify", fontSize: "18px", color: "#555" }}>
                PARSO (Particle-packing and Radiation Shielding Optimizer) is a software tool
                designed to evaluate and/or optimize material mixtures for enhanced particle packing and radiation shielding performance.
                <br />
                <br />
               The tool evaluates a range of radiation shielding properties, including gamma-ray mass and linear attenuation coefficients,
               fast neutron removal cross-sections, thermal neutron cross-sections, effective atomic number, and equivalent atomic number.
               It also evaluates particle-packing characteristics to support the development and optimization of high-performance concrete mixtures,
               including ultra-high-performance concrete (UHPC).
               By streamlining the mixture design process and providing detailed analytical capabilities, PARSO helps users achieve
               optimal performance and safety standards in their projects.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        {/* Right Column (Image or Visual) */}
        <Col xs={12} md={6}>
          <Image
            src="/images/Software/SoftwareInterface2.png" // Change this to an image of the software or relevant graphic
            alt="PARSO Software Interface"
            fluid
            style={{
              // borderRadius: "10px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
              width: "100%",
              objectFit: "cover",
            }}
          />
        </Col>
        </Row>
</Container>

        {/* Features */}
        {/* Features */}
        {/* Features */}
      {getSectionHeading("Features")}

        {/* Radiation Shielding */}
        {/* Radiation Shielding */}
        {/* Radiation Shielding */}
        <FeaturesRow title={"Radiation Interaction Cross-Sections"} textLeft={true} media={
          <Image src="/images/Home/Reactor.png" fluid />
        } style={{ marginTop: "50px"}}>
            <ul>
              <li>Supports <strong>gamma attenuation coefficient calculations</strong> using NIST XCOM and NIST X-ray databases</li>
              <li>Computes <strong>neutron cross-sections</strong> using ENDF/B-VIII.0, JEFF-3.3, JENDL-5, TENDL, and other full-spectrum neutron databases</li>
              <li>Calculates <strong>effective atomic number (Z<sub>eff</sub>)</strong> and <strong>equivalent atomic number (Z<sub>eq</sub>)</strong></li>
              <li>Supports <strong>compositional optimization</strong> by varying material proportions to improve shielding against target radiations</li>
              {/* <li>Covers <strong>both thermal and fast neutron energies</strong> with database cross-comparisons</li> */}
            </ul>
        </FeaturesRow>


        {/* Particle Packing */}
        {/* Particle Packing */}
        {/* Particle Packing */}
        <FeaturesRow title={"Particle Packing"} textLeft={false} media={
          <Image src="/images/Home/ParticlePacking.png" fluid />
        } style={{marginTop: "150px"}}>
            <ul>
              <li>Evaluates mixtures <strong>packing density</strong> using the modified andreasen and andersen model</li>
              <li>Includes <strong>Sum of Squared Error (SSE)</strong> as a performance indicator for packing fit</li>
              <li>Supports <strong>compositional optimization</strong> by varying material proportions to improve packing</li>
            </ul>
        </FeaturesRow>

        {/* Mixture Design */}
        {/* Mixture Design */}
        {/* Mixture Design */}
        <FeaturesRow title={"Mixture Design and Optimization"} textLeft={true} style={{marginTop: "150px"}} media={
          <Image src="/images/Home/Optimization.png" fluid />
        }>
          <ul>
            {/* Design-related */}
            <li>Input your own materials with detailed <strong>chemical composition and particle size distribution (PSD)</strong></li>
            <li>Support for <strong>Loss on Ignition (LOI) adjustment</strong>, with automatic normalization of remaining elements</li>
            <li>Estimate <strong>mixtures density, cost, embodied energy, and embodied CO₂</strong></li>
            
            {/* Optimization-related */}
            <li>Perform <strong>single- and multi-objective optimizations</strong> across shielding and packing goals</li>
            <li>Use <strong>sequential optimization</strong> workflows: e.g., optimize for gamma shielding, then refine for packing</li>
            <li>Screen <strong>thousands of mixtures per run</strong></li>
            <li>Built-in support for <strong>multi-core CPUs</strong> to drastically reduce computation time</li>
          </ul>
        </FeaturesRow>






        {/* The Team */}
        {/* The Team */}
        {/* The Team */}
<Container style={{ marginTop: "100px" }}>
  <h1 className="text-center display-4 fw-bold mb-4">Meet the Team</h1>
  <div
    style={{
      width: "100px",
      height: "4px",
      backgroundColor: "#000",
      margin: "0 auto 40px auto",
      borderRadius: "2px",
    }}
  />

  {teamMembers.map((member, index) => (
    <Row
      key={index}
      className="align-items-center my-5 py-4 px-3 rounded shadow-sm"
      style={{
        background: "linear-gradient(145deg,rgb(196, 195, 195), #e9e9e9)",
        border: "1px solid #ccc",
      }}
    >
      <Col
        xs={12}
        md={3}
        className="d-flex justify-content-center mb-3 mb-md-0"
      >
        <Image
          className="zoom-hover"
          src={member.image}
          alt={member.name}
          style={{
            width: "220px",
            height: "220px",
            objectFit: "cover",
            borderRadius: "50%",
            border: "5px solid white",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          }}
        />
      </Col>

      <Col xs={12} md={9}>
        <h2 className="fw-bold mb-2">{member.name} - {member.role}</h2>
        <h5 className="text-muted mb-3">{member.position}</h5>
        <p style={{ fontSize: "1.1rem", lineHeight: "1.6", textAlign: "justify" }}>
          {member.description}
        </p>
        <div className="mt-3 d-flex flex-wrap gap-3">
          {member.website && SocialIcon({icon:"images/Icons/web-link.png", url:member.website, tooltip:"Website"})}
          {member.email && SocialIcon({icon:"images/Icons/mail.png", url:"mailto:"+member.email, tooltip:"Email"})}
          {member.linkedin && SocialIcon({icon:"images/Icons/linkedin.png", url:member.linkedin, tooltip:"LinkedIn"})}
          {member.scholar && SocialIcon({icon:"images/Icons/Google Scholar.png", url:member.scholar, tooltip:"Google Scholar"})}
          {member.researchgate && SocialIcon({icon:"images/Icons/Research Gate.webp", url:member.researchgate, tooltip:"Research Gate"})}
        </div>
      </Col>
    </Row>
  ))}
</Container>





        {/* End of page container */}
        {/* End of page container */}
        {/* End of page container */}
<Container style={{ marginTop: "100px" }}>
  <motion.div
    initial={{ opacity: 0, y: -50 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 1 }}
    viewport={isMobile ? { once: true } : { once: false }}
  >
    <h2
      className="text-center display-4 fw-bold"
      style={{
        marginBottom: "40px",
        fontSize: "2.5rem", // Larger font size for emphasis
        color: "#333", // Dark color for better contrast
      }}
    >
      You have reached the end of the page. Check out the other pages.
    </h2>
  </motion.div>

  <Row className="justify-content-center">
    {otherPages.map((otherPage, index) => getOtherPageColumn(otherPage, isMobile, index))}
  </Row>
</Container>





      </Container>

    </>
  );
};


const getSectionHeading = (title: string) => {
    return (
    <>
      <h1 className="text-center display-4 fw-bold mb-4">{title}</h1>
      <div
        style={{
          width: "100px",
          height: "4px",
          backgroundColor: "#000",
          margin: "0 auto 40px auto",
          borderRadius: "2px",
        }}
      />
    </>
  );
}

const getOtherPageColumn = (otherPage: OtherPage, isMobile: boolean, index: number) => {
  return <Col
      xs={{ span: 12, order: 0 }}
      lg={{ span: 3, order: 0 }}
    >
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={
          isMobile
            ? { duration: 0.5, delay: 0.5 }
            : { duration: 0.5, delay: 0.5+ index * 0.3 }
        }
        viewport={{ once: isMobile }}
        className="d-flex flex-column align-items-center gap-2" //d-flex flex-column: ensures vertical stacking, align-items-center: centers both image and button horizontally, gap-2 (optional): adds some spacing between the image and button (Bootstrap spacing utility)
      >
            <Image src={otherPage.imageSrc} style={{width: "100px", height: "100px"}}/>
        <Button
          variant="secondary"
          href={otherPage.href}
          style={{
            fontSize: "1.1rem", // Slightly larger text for the button
            padding: "10px 20px", // Better button padding for easier interaction
            borderRadius: "30px", // Rounded button for smoother aesthetics
          }}
          className="mt-2 transition-all hover:bg-dark"
        >
              {otherPage.buttonText}
            </Button>
      </motion.div>
    </Col>
}

const SocialIcon: React.FC<{ icon: string; url: string; tooltip: string }> = ({ icon, url, tooltip }) => {
return <OverlayTrigger
    placement="top"
    overlay={<Tooltip>{tooltip}</Tooltip>}
  >
    <a href={url} target="_blank" rel="noopener noreferrer">
      <Image
        className="social-icon"
        src={icon}
        width="40px"
        height="40px"
      />
    </a>
  </OverlayTrigger>
}
